module.exports = __webpack_public_path__ + "img/02_1_5_1.53f59245.png";